module.exports = __webpack_public_path__ + "static/media/10ю091.68ece44e.webp";